export const pageClasses = {
  root: 'page',
  body: 'page__body',
  header: 'page__header',
  title: 'page__title',
};
